import React from 'react';
import AruanaKayarRender from "./AruanaKayarRender";
import AruanaIataRender from "./AruanaIataRender";
import SilkKayarRender from "./SilkKayarRender";
import SiteKayarRender from "./SiteKayarRender";
import YanaKayarRender from "./YanaKayarRender";
import GoogleKayarRender from "./GoogleKayarRender";
import RateHawkKayarRender from "./RateHawkKayarRender";
import SpecialSilkKayarRender from "./SpecialSilkKayarRender";
import KayarTransaviaRender from "./kayarTransaviaRender";

const RacoonResultRoute = ({type, data, onReload}) => {
  return (
    <div className={'mt-4'}>
      <h3>Результаты сверки</h3>
      <br/>
      {type === 'ak' ? <AruanaKayarRender data={data}/>
        : type === 'ai' ? <AruanaIataRender data={data}/>
          : type === 'ks' ? <SilkKayarRender data={data}/>
            : type === 'sk' ? <SiteKayarRender data={data}/>
              : type === "yk" ? <YanaKayarRender data={data} onReload={onReload}/>
                : type === "kg" ? <GoogleKayarRender data={data}/>
                  : type === "ssk" ? <SpecialSilkKayarRender data={data}/>
                    : type === "kt" ? <KayarTransaviaRender data={data}/> :
                  <RateHawkKayarRender data={data}/>}
    </div>
  );
};

export default RacoonResultRoute;
